import React, { useState, useEffect } from 'react';
import Icon from './icons';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS, APIS, STORAGE } from '../_config';
import { Link, useNavigate, Outlet, Navigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useStoreSelector, useAuthStatus, useStoreBrnDSSelector } from '../store/selectors/userSelector';
import { useStoreApi } from '../store/api/hooks/storeApiHook';
import { useDataSourceApi } from '../store/api/hooks/dataSourceApiHook';
import { SwalService } from './confirmation-popup/swalService';
import Spinner from './iconSvgs/spinner';
import { AnyListenerPredicate } from '@reduxjs/toolkit';

const Header: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const store = useStoreSelector();
    const branchDS = useStoreBrnDSSelector();
    const storeAPI = useStoreApi();
    const dataSourceAPI = useDataSourceApi();
    // console.log('store =>', branchDS, branchDS?.branch_name);
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [branches, setBranches] = useState<any[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<any>(branchDS);


    useEffect(() => {
        const data: any = {
            store_id: store?.store_id
        };
        getBranches(data);
    }, []);

    const getBranches = (data: any) => {
        storeAPI.getStoreBranches(data, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            setBranches(resp.data);
        }, (err: any) => {
            toast.error(err);
        })
    }

    const handleBranchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedBranch = JSON.parse(e.target.value);
        handleClick(selectedBranch);
    };

    const handleSubmit = (branch: any) => {
        onSubmit(branch);
    };

    const handleClick = (branch: any) => {
        SwalService.triggerSwal(
            'Default Branch',
            'Are you sure you want to change store branch?',
            () => handleSubmit(branch)
        );
    };

    const onSubmit = (branch: any) => {
        // console.log('selectedBranch =>', selectedBranch);
        setOnSubmitLoading(true);
        const param: any = {
            branch_id: branch?.branch_id,
        }
        try {
            setTimeout(() => {
                dataSourceAPI.getDataSource(param, (msg: any, resp: any) => {
                    if (resp?.code === 200) {
                        if (resp.data.length > 0) {
                            let inPending: any = null;
                            let failure: any = null;
                            const completed = resp?.data.find((item: any) => item.last_fetch_status === 'completed');
                            if (!completed) {
                                inPending = resp?.data.find((item: any) => item.last_fetch_status === 'pending');
                                if (!inPending) {
                                    failure = resp?.data.find((item: any) => !item.last_fetch_status);
                                }
                            }
                            if (completed) {
                                dispatch({
                                    type: ACTIONS.STORE.GET_BRANCH,
                                    payload: completed,
                                })
                                navigate(URLS.DASHBOARD);
                            } else if (inPending) {
                                dispatch({
                                    type: ACTIONS.STORE.GET_BRANCH,
                                    payload: inPending,
                                })
                                navigate(URLS.DATASOURCES.LIST);
                            } else {
                                dispatch({
                                    type: ACTIONS.STORE.GET_BRANCH,
                                    payload: failure,
                                })
                                navigate(URLS.DATASOURCES.LIST);
                            }
                        }
                        // window.location.reload();
                    } else if (resp?.code === 404) {
                        toast.error(resp?.message);
                        const payload = {
                            source_type: null,
                            url: null,
                            last_fetch_date: null,
                            created_at: null,
                            ds_id: null,
                            store_id: store?.store_id,
                            branch_id: branch?.branch_id,
                            branch_name: branch?.branch_name,
                            snapshot_id: null,
                            last_fetch_status: null
                        }
                        dispatch({
                            type: ACTIONS.STORE.GET_BRANCH,
                            payload: payload,
                        })
                        navigate(URLS.DATASOURCES.CREATE);
                        // window.location.reload();
                    }
                }, (error: any, resp: any) => {
                    console.log('error =>', error, resp);
                    if (resp?.detail?.code === 404) {
                        toast.error(resp?.detail?.message);
                        const payload = {
                            source_type: null,
                            url: null,
                            last_fetch_date: null,
                            created_at: null,
                            ds_id: null,
                            store_id: store?.store_id,
                            branch_id: branch?.branch_id,
                            branch_name: branch?.branch_name,
                            snapshot_id: null,
                            last_fetch_status: null
                        }
                        dispatch({
                            type: ACTIONS.STORE.GET_BRANCH,
                            payload: JSON.stringify(payload),
                        })
                        navigate(URLS.DATASOURCES.CREATE);
                        // window.location.reload();
                    } else {
                        toast.error("Something went wrong");
                    }
                })
                setOnSubmitLoading(false);
            }, 3000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    return (
        <>
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            <div className="flex w-full bg-white p-3 rounded-r-md -mb-5 justify-between">
                <div className='ipad-padding-left'>
                    <h4 className='font-semibold text-gray-500'>{store?.name}</h4>
                </div>
                <div className="flex space-x-4 relative justify-end">

                    <select className="block w-auto rounded-sm bg-grey-200 px-3 py-1.5 pr-10 text-lg text-gray-700 custom-text-black"
                        // value={selectedBranch?.branch_id}
                        style={{
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            MozAppearance: 'none',
                            backgroundImage: 'none',
                        }}
                        onChange={(e) => handleBranchChange(e)}
                    >
                        <option value="" disabled className='text-gray-400'>
                            Branch
                        </option>
                        {branches.length > 0 ? (
                            branches.map((brn: any, index: any) => (
                                <option key={index} value={JSON.stringify(brn)} className="text-gray-500 pointer-events-auto" selected={selectedBranch?.branch_id === brn.branch_id}
                                >
                                    {brn.branch_name}
                                </option>
                            ))
                        ) : null}
                    </select>
                    <Icon name="arrow-down" size={20} className="absolute right-4 top-[20px] transform -translate-y-1/2 text-black hover:bg-transparent focus:outline-none" />

                </div>
            </div>
        </>
    )
}
export default Header;